import { fromJS } from "immutable";
import { Action, reducerFn, ReducerState } from "../../helpers/reducers";
import {
    PAGE_SET,
    PAGE_CLEAR,
    PAGE_REMOVE,
    PAGE_SET_MULTIPLE,
} from "./actions";

interface Page {
    id: string;
    page_id: string;
    data: any;
}

type PageAction = Action<Page> & Action<Array<Page>>;

const fnMap = {
    [PAGE_CLEAR]: (s: ReducerState) => s.clear(),
    [PAGE_SET]: (s: ReducerState, { payload: { id, data } }: PageAction) =>
        // @ts-ignore
        s.set(parseInt(id, 10), fromJS(data)),
    [PAGE_REMOVE]: (s: ReducerState, { payload: { page_id } }: PageAction) =>
        // @ts-ignore
        s.delete(parseInt(page_id)),
    [PAGE_SET_MULTIPLE]: (s: ReducerState, { payload: rows }: PageAction) => {
        for (let r of rows) {
            // @ts-ignore
            s = s.set(parseInt(r.id, 10), fromJS(r));
        }
        return s;
    },
};

const initialState = {};
export const pagesReducer = reducerFn("pages", initialState, fnMap, {
    type: "OrderedMap",
});
